module.exports = __webpack_public_path__ + "98a2d52fe6eb5224cd6e7cfe927e155e.svg";